import { FilterOptionsProps, GetValuesFromUrlParams, SelectedValues } from './interfaces';

export const getValuesFromUrl = ({ filters, searchParams, extrasFilters }: GetValuesFromUrlParams) => {
	const values: { name: string; values: string[] }[] = [];

	filters?.forEach((filter) => {
		const filterValues = searchParams?.get(filter.name);

		if (filter.name === 'lancamentos' && filterValues === 's') {
			values.push({
				name: filter.name,
				values: ['Ver lançamentos'],
			});
		} else if (filterValues) {
			values.push({
				name: filter.name,
				values: filterValues.split(','),
			});
		}
	});

	extrasFilters?.forEach((extraFilter) => {
		if (extraFilter.paramName) {
			const filterValues = searchParams?.get(extraFilter.paramName);

			if (filterValues && !values.some(({ name }) => name === extraFilter.paramName)) {
				values.push({ name: extraFilter.paramName, values: filterValues.split(',').filter(Boolean) });
			}
			return;
		}

		const extraFilterValue = searchParams?.get(extraFilter.label);

		if (extraFilterValue === 's') {
			values.push({
				name: extraFilter.label,
				values: [extraFilter.value],
			});
		}
	});

	return values;
};

export const filterTypes = ['categorias', 'marcas', 'mecanicas', 'vigencia', 'lancamentos', 'promocoes'];

/** Atualiza a URL sem remover parametros independentes dos filtros aplicados. */
export function getFilterSearchParams(
	search: URLSearchParams,
	selectedValues: SelectedValues,
	extrasFilters: FilterOptionsProps[] = [],
	removeFilters = false,
): URLSearchParams {
	const next = new URLSearchParams(search);
	const groupedNames = extrasFilters.flatMap(({ paramName }) => (paramName ? [paramName] : []));
	const namesToRemove = removeFilters ? [...filterTypes, ...groupedNames] : groupedNames;

	namesToRemove.forEach((name) => {
		if (!selectedValues.some((section) => section.name === name && section.values?.length)) next.delete(name);
	});

	selectedValues.forEach(({ name, values }) => {
		const isBoolean = name === 'lancamentos' || extrasFilters.some((extra) => !extra.paramName && extra.label === name);
		const value = isBoolean ? 's' : values?.join(',') || '';

		if (value) next.set(name, value);
		else next.delete(name);
	});

	return next;
}
